var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTargetMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.71429 10.2059V14.1429C7.71429 14.6162 8.09804 15 8.57143 15H15.4286C15.902 15 16.2857 14.6162 16.2857 14.1429V10.2058L12.8518 12.3521C12.3306 12.6778 11.6694 12.6778 11.1482 12.3521L7.71429 10.2059Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3848 9H8.61505L11.9432 11.0801C11.978 11.1018 12.022 11.1018 12.0568 11.0801L15.3848 9Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 11.2479C2.36618 6.30929 6.30929 2.36618 11.2479 2V3.97778C11.2479 4.39314 11.5846 4.72986 12 4.72986C12.4154 4.72986 12.7521 4.39314 12.7521 3.97778V2C17.6907 2.36618 21.6338 6.30929 22 11.2479H20.0222C19.6069 11.2479 19.2701 11.5846 19.2701 12C19.2701 12.4154 19.6069 12.7521 20.0222 12.7521H22C21.6338 17.6907 17.6907 21.6338 12.7521 22V20.0222C12.7521 19.6069 12.4154 19.2701 12 19.2701C11.5846 19.2701 11.2479 19.6069 11.2479 20.0222V22C6.30929 21.6338 2.36618 17.6907 2 12.7521H3.97778C4.39314 12.7521 4.72986 12.4154 4.72986 12C4.72986 11.5846 4.39314 11.2479 3.97778 11.2479H2ZM18 12C18 8.68629 15.3137 6 12 6C8.68629 6 6 8.68629 6 12C6 15.3137 8.68629 18 12 18C15.3137 18 18 15.3137 18 12Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTargetMail);
export default __webpack_public_path__ + "static/media/target-mail.740da0ba4ddba35b95ab7c25b57e524c.svg";
export { ForwardRef as ReactComponent };